import { Link } from 'react-router-dom';
import EmptyState from '@/components/feature/EmptyState';
import { specials } from '@/mocks/specials';

export default function Specials() {
  return (
    <div className="w-full bg-background-50">
      <div className="w-full px-4 md:px-8 py-8 md:py-10">
        <div className="max-w-screen mx-auto">
          <nav className="text-xs md:text-sm text-foreground-600 mb-4 flex items-center gap-1.5">
            <Link to="/" className="hover:text-primary-400 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">专题合集</span>
          </nav>

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-black text-foreground-950 mb-2">专题合集</h1>
            <p className="text-sm text-foreground-600 max-w-3xl">
              由编辑团队精心策划的电影专题，围绕主题、类型与情绪为你集结成片单。不知道看什么的时候，从一个专题开始吧。
            </p>
          </div>

          {specials.length === 0 ? (
            <div className="bg-background-100 border border-background-300/50 rounded-lg">
              <EmptyState icon="ri-gallery-line" title="暂无专题内容" description="专题正在筹备中，敬请期待。" />
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {specials.map((special) => (
                <Link
                  key={special.id}
                  to={`/specials/${special.id}`}
                  className="group bg-background-100 border border-background-300/50 rounded-lg overflow-hidden hover:border-primary-500/60 transition-colors"
                >
                  <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                    <img
                      src={special.cover}
                      alt={`${special.title} 专题主图`}
                      title={`${special.title} - 电影专题合集`}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-semibold">
                      {special.movieIds.length} 部影片
                    </span>
                  </div>
                  <div className="p-5">
                    <h2 className="text-base md:text-lg font-bold text-foreground-950 mb-1 group-hover:text-primary-400 transition-colors">
                      {special.title}
                    </h2>
                    <p className="text-xs text-foreground-600 mb-3">{special.subtitle}</p>
                    <p className="text-sm text-foreground-700 leading-relaxed line-clamp-3">{special.description}</p>
                    <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-400">
                      查看专题 <i className="ri-arrow-right-s-line"></i>
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}